    import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import { resetAll } from "./actions/resetAll";

const initialState: {[key:string] : string} = {}

const corPorAmbienteSlice = createSlice({
    name: "corPorAmbiente",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        associarCor: (corPorAmbiente, action: PayloadAction<{ambiente: string, cor:string}>) => {
            corPorAmbiente[action.payload.ambiente] = action.payload.cor
        },
        desassociarCor: (corPorAmbiente, action: PayloadAction<{ambiente: string, cor: string}>) => {
            corPorAmbiente[action.payload.ambiente] = null
        }
    }
})

export const {
    associarCor: associarCorAction,
    desassociarCor: desassociarCorAction
} : {
    associarCor: ActionType<{ambiente: string, cor:string}>,
    desassociarCor: ActionType<{ambiente: string, cor:string}>
} = corPorAmbienteSlice.actions

export default corPorAmbienteSlice.reducer